import { render } from "./CreateUpdateIntegration.vue?vue&type=template&id=5e21a470&ts=true"
import script from "./CreateUpdateIntegration.vue?vue&type=script&lang=ts"
export * from "./CreateUpdateIntegration.vue?vue&type=script&lang=ts"

import "./CreateUpdateIntegration.vue?vue&type=style&index=0&id=5e21a470&lang=css"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__